export const useRem = (): number => {
    const rem = getComputedStyle(document.documentElement).fontSize
    const remValue = Number(rem.match(/\d*/)?.[0])
    if (isNaN(remValue)) return 16
    return remValue
}
